import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {IConversationTypeInterfacesMap} from '@toolify/server/src/services/MessageService/types/IConversationTypeInterfacesMap'

type AnyConversationPayload = IConversationTypeInterfacesMap[ConversationType]['conversationTypePayload']
type CloudFilePayload = IConversationTypeInterfacesMap[ConversationType.CloudFile]['conversationTypePayload']

export function useCloudFileConversationTypeStrategy() {
  const getConversationKey = (payload: AnyConversationPayload): string => {
    return (payload as CloudFilePayload).cloudItemId
  }

  const getRelayConversationKey = (payload: AnyConversationPayload): string => {
    return (payload as CloudFilePayload).cloudItemId
  }

  return {
    getConversationKey,
    getRelayConversationKey,
  }
}
